class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', event => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') ||
        this.closest('cart-items');
        cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.progress = this.getAttribute('data-progress');
  }

  connectedCallback() {
    setTimeout(() => {
      this.querySelector('[data-progress-line]').style.width = this.progress;
    }, 100);
  }
}

customElements.define('progress-bar', ProgressBar);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );
    this.debouncedOnChange = debounce(event => {
      this.onChange(event);
    }, 300);
    this.addEventListener(
      'change',
      this.debouncedOnChange.bind(this)
    );
    $('.upsell-product-cart-drawer').owlCarousel({
      nav: true,
      dots: false,
      loop: false,
      margin:15,
      responsive: {
        0: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });
     // gift product upsell cart drawer
  $(".gift-product-cart-drawer").owlCarousel({
    nav: false,
    dots: true,
    loop: false,
    margin: 15,
    responsive: {
      0: {
        items: 1,
      },
      1200: {
        items: 1,
      },
    },
  });
    $('.cart-drawer .upsell_variant_select').change(function () {
     var selectedVariantId = $(this).find(':selected').attr('option-variant-id');
      $(this).parents('.upsell-product-container').find('.upsell-product-ajax').attr('upsell-product-variant', selectedVariantId);
      $(this).parents('.free-gift-product-container').find('.free-gift-product-btn').attr('upsell-product-variant', selectedVariantId);

      // upsell product src image change
       var selectedVariantImage = $(this).find(':selected').attr('option-variant-image');
      $(this).parents('.upsell-product-container.v1').find('.upsell-product-image img').attr('src', selectedVariantImage);
      $(this).parents('.free-gift-product-container').find('.free-gift-product-image img').attr('src', selectedVariantImage);

      // upsell product price replace
       var selectedValue = $(this).find(':selected').attr('option-variant-price');
      $(this).parents('.upsell-product-container').find('.upsell-product-price .price_product').text(selectedValue);
      $(this).parents('.free-gift-product-container').find('.free-gift-product-price').text(selectedValue);
    });
    //Set country size selected on basis of country visitors
      const apiUrl = 'https://ipinfo.io/json/';
      fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          const location = {
            city: data.city,
            region: data.region,
            country: data.country,
            latitude: data.loc.split(',')[0],
            longitude: data.loc.split(',')[1]
          };
          $('[data-country-name]').hide();
          let countrySelectors = location.country;
          if (countrySelectors == 'DE' || countrySelectors == 'AT' || countrySelectors == 'NL' || countrySelectors == 'CH' || $('body').hasClass('germany') ||  $('body').hasClass('austria') || $('body').hasClass('netherlands') ||  $('body').hasClass('switzerland')) {
            $('[data-country-name="DE,AT,NL,Ch"]').show();
          } else if (countrySelectors == 'SE' || countrySelectors == 'NO' || countrySelectors == 'DK' ||  countrySelectors == 'FI' || $('body').hasClass('sweden') || $('body').hasClass('norway') || $('body').hasClass('denmark') || $('body').hasClass('finland')) {
            $('[data-country-name="SE,NO,DK,FI"]').show();
          }else if (countrySelectors == 'GB' || countrySelectors == 'IE' || countrySelectors == 'AU' || countrySelectors == 'NZ' || $('body').hasClass('united-kingdom') || $('body').hasClass('Ireland') || $('body').hasClass('australia') || $('body').hasClass('new-zealand')) {
            $('[data-country-name="UK,IE,AU,NZ"]').show()
          }else if (countrySelectors == 'FR' || countrySelectors == 'BE' || $('body').hasClass('france') || $('body').hasClass('belgium')) {
            $('[data-country-name="FR,BE"]').show();
          }else {
            $('[data-country-name="US"]').show();
          }
        })
        .catch(error => console.error(error));
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return [
      {
        id: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        }`,
        section:
          document.getElementById('main-cart-items').dataset.id,
        selector: `#shopify-section-${
          document.getElementById('main-cart-items').dataset.id
        } cart-items`
      },
      {
        id: '#cart-counter',
        section: 'cart-counter',
        selector: '#shopify-section-cart-counter'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map(
        section => section.section
      ),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body }
    })
      .then(response => response.text())
      .then(state => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach(section => {
          const elementToReplace =
            section.id === '#cart-counter'
              ? document.querySelector(section.id)
              : document.querySelector(section.selector);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        this.updateLiveRegions(line, parsedState.item_count);
        document.querySelector('.cart-drawer .cart-item-count').textContent = parsedState.item_count;
        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .querySelectorAll(
          `[data-line-item-error][data-line="${line}"]`
        )
        .forEach(error => {
          error.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            document.querySelector(`[id*="ProductQuantity-${line}"]`)
              .value
          );
        });
    }

    this.currentItemCount = itemCount;
  }
}

customElements.define('cart-items', CartItems);
